((Product, $) => {
  'use strict';

  let $dom = {};
  let recommended = false;
  let recSlider = false;
  let proteinBarSelected = false;

  const tierOnePercentage = parseInt(globals.tierOnePercentage);
  const isMobile = () => window.innerWidth < 1021;
  const isMobileBrowser = () => /android|ip(hone|od|ad)/i.test(navigator.userAgent);
  const hasBenefits = () => $('.pdp__benefits').length > 0;
  const hasApparelInfo = () => $('.pdp__apparel-info').length > 0;

  const cacheDom = () => {
    if (hasBenefits()) {
      $dom.infoList = $('.pdp__benefits .stack li');
      $dom.infoContent = $('.pdp__benefits-content .item');
    } else if (hasApparelInfo()) {
      $dom.infoList = $('.pdp__apparel-info .stack li');
      $dom.infoContent = $('.pdp__apparel-info-content .item');
    }

    $dom.window = $(window);
    $dom.globals = $dom.window.globals;
    $dom.mobileAccordionHeaders = $('.pdp-accordion-header');
    $dom.mobileAccordionContent = $('.pdp-accordion-content');
    $dom.recommendedDesktop = $('.pdp__recommended');
    $dom.lineBreaks = $('.pdp__benefits br + br');
    $dom.quantitySelector = $('.js-product-quantity');
    $dom.quantityButtons = $('[data-quantity-buttons] a');
    $dom.optionContainer = $('.js-product-option-group-container');
    $dom.pdpFreeSamplesOptionContainer = $('.js-product-freesample-group-container');
    $dom.pdpFreeSamplesFootnote = $('.js-product-freesamples-footnote');
    $dom.optionsBlock = $('[data-options-block]');
    $dom.giftOption = $('.js-gift-option');
    $dom.addToCart = $('.js-add-to-cart');
    $dom.price = $('.js-price');
    $dom.styledSelects = $('.js-style-select');
    $dom.register = $('.register');
    $dom.thumbnails = $('.product-thumbnails li');
    $dom.productSlider = $('.product-slider');
    $dom.desktopImageBlock = $('[data-desktop-image-block]');
    $dom.variantSelect = $('.js-variant-select');
    $dom.mobileOptionMenu = $('[data-mobile-options]');
    $dom.mobileOptionButtons = $('[data-mobile-options] button[data-variant-alt]');
    $dom.mobileOptionMenuCloseButton = $('button[data-close-mobile-options]');

    $dom.productPriceMinimum = $('.product-price-minimum');
    $dom.productPriceCompare = $('.product-price-compare');
    $dom.relatedPriceTotal = $('.js-related-price-total');
    $dom.relatedComparePriceTotal = $('.js-related-compare-price-total');
  };

  const setSavings = () => {
    const setProductSavings = (priceMinimum, priceCompare, appendTo) => {
      const price = priceMinimum.data('price') || false;
      const compare = priceCompare.data('price') || false;
      const elementToappendTo = appendTo.selector;
      const pdpProduct = $('.pdp__product');
      const testingMsg = document.querySelector('.testing-msg');

      if (price && compare) {
        const savings = Math.floor(((compare - price) / compare) * 100);
        priceCompare.siblings('.product-savings').empty().remove();
        let targetEl = elementToappendTo;

        if (testingMsg) {
          testingMsg.innerHTML = savings + '%';
        }

        if (targetEl) {
          $(`<span class="product-savings">Save ${savings}%!</span>`).insertAfter(targetEl);
        }
      }
    };

    setProductSavings($dom.productPriceMinimum, $dom.productPriceCompare, $dom.productPriceCompare);

    $('.pdp__related-product-price').each((i, relatedProductPriceWrapper) => {
      const relatedPrice = $(relatedProductPriceWrapper).find('.js-related-price');
      const relatedCompare = $(relatedProductPriceWrapper).find('.js-related-compare-price');
      setProductSavings(relatedPrice, relatedCompare, relatedCompare);
    });

    $dom.relatedPriceTotal.on('products-bought-together:changed', () => {
      setProductSavings($dom.relatedPriceTotal, $dom.relatedComparePriceTotal, 'related-product-saving-total');
    });

    $('<span class="product_option_title">Select Option:</span>').insertBefore('#product-variants');

    function tieredDiscountSavings() {
      let product_wrapper = $('.pdp__container .regular-product .pdp__form .product-submit-wrapper');
      if (product_wrapper.length == 0) {
        setTimeout(tieredDiscountSavings, 100);
        return;
      }
      let comparePrice = document.querySelectorAll(
        '.pdp__container .regular-product .pdp__price .product-price .product-price-compare'
      );
      let cta = product_wrapper.find('.btn');
      let product_price_wrapper = document.querySelectorAll('.pdp__container .regular-product .pdp__price');
      let product_price_desktop = $(
        '.pdp__container .regular-product .pdp__price.pdp__price--desktop .product-price .orig-price'
      );
      let product_price_mobile = $(
        '.pdp__container .regular-product .pdp__price.pdp__price--mobile .product-price .product-price-minimum'
      );
      let product_price = $('.pdp__container .regular-product .pdp__price .product-price span').first();
      let price = product_price.text().substring(1);
      let quantity = document.querySelector('[data-current-quantity]').innerText;
      product_price_wrapper.forEach((item) => {
        item.classList.add('tiered-discount-wrapper');
        item.querySelector('.product-savings');
      });

      cta.after(
        $(
          `<button type="button" class="tiered-discount-add-to-cart-cta btn btn--red btn--large">Add to cart - $${price}</button>`
        )
      );

      product_price_desktop.after(
        $(
          `<span class="tiered-discount-main-price product-price-minimum money js-price" itemprop="price" data-price="${product_price.attr(
            'data-price'
          )}" data-sezzleindex="0">${product_price.text()}</span><span class="discount-message"></span>`
        )
      );

      product_price_mobile.after(
        $(
          `<span class="tiered-discount-main-price product-price-minimum money js-price" itemprop="price" data-price="${product_price.attr(
            'data-price'
          )}" data-sezzleindex="0">${product_price.text()}</span><span class="discount-message"></span>`
        )
      );

      const targetNode = document.querySelector(
        '.pdp__container .pdp__product .pdp__form .quantity-buttons__inner span'
      );

      // If the qty is 1, and there is a compare price on a non-bundle/stack product, show the compare price until the qty is increased
      if (comparePrice && quantity == '1') {
        product_price_wrapper.forEach((item) => {
          item.classList.add('has-compare-price');
        });
      }

      const config = {
        attributes: true,
        childList: true,
        subtree: true,
      };

      let callback;
      let observer;

      callback = (mutationList) => {
        for (const mutation of mutationList) {
          let add_to_cart_cta = $('.tiered-discount-add-to-cart-cta');
          let main_price = $('.tiered-discount-main-price');
          let price = $('.pdp__price .product-price span').first().text().substring(1);
          let savings_percentage = 0;
          let discountMessage = $('.discount-message');
          let quantity = parseInt(mutation.target.innerText);
          const tierOneThreshold = parseInt(globals.tierOneThreshold);
          const tierOnePercentage = parseInt(globals.tierOnePercentage);
          const tierTwoThreshold = parseInt(globals.tierTwoThreshold);
          const tierTwoPercentage = parseInt(globals.tierTwoPercentage);
          const tierThreeThreshold = parseInt(globals.tierThreeThreshold);
          const tierThreePercentage = parseInt(globals.tierThreePercentage);

          if (quantity > 1) {
            if (quantity >= tierOneThreshold && quantity < tierTwoThreshold) {
              savings_percentage = tierOnePercentage;
              discountMessage.text(`Save ${tierOnePercentage}%!`);
            } else if (quantity >= tierTwoThreshold && quantity < tierThreeThreshold) {
              savings_percentage = tierTwoPercentage;
              discountMessage.text(`Save ${tierTwoPercentage}%!`);
            } else if (quantity >= tierThreeThreshold) {
              savings_percentage = tierThreePercentage;
              discountMessage.text(`Save ${tierThreePercentage}%!`);
            }

            let discount_price = (-price * (savings_percentage / 100 - 1)).toFixed(2);
            main_price.html(`$${discount_price} <span class="tiered-discount-original-price">$${price}</span>`);
            add_to_cart_cta.html(
              `Add to cart - $${discount_price} <span class="tiered-discount-original-price">$${price}</span>`
            );
            product_price_wrapper.forEach((item) => {
              item.classList.remove('has-compare-price');
            });
          } else {
            savings_percentage = 0;
            main_price.html(`$${price}`);
            add_to_cart_cta.html(`Add to cart - $${price}`);
            discountMessage.text('');
            product_price_wrapper.forEach((item) => {
              item.classList.add('has-compare-price');
            });
          }
        }
      };

      observer = new MutationObserver(callback);
      observer.observe(targetNode, config);
    }

    function tieredDiscountSavingsEvents() {
      let cta = $('.tiered-discount-add-to-cart-cta');
      if (cta.length == 0) {
        setTimeout(tieredDiscountSavingsEvents, 50);
        return;
      }

      cta.on('click', function () {
        window.$('.pdp__container .pdp__product .pdp__form .btn[id="AddToCart"]').click();
      });
    }

    $(document).ready(function () {
      tieredDiscountSavings();
      tieredDiscountSavingsEvents();
    });
  };

  const processLineBreaks = () => {
    $dom.lineBreaks.each((index, element) => {
      if (element.previousSibling.nodeValue && element.previousSibling.nodeValue.trim() == '') {
        $(element).addClass('is-line-break');
      }
    });
  };

  const initRecommendationsSlider = () => {
    recSlider = $('.pdp__recommended .promoted-products-box ul.promoted-products');
    if (recSlider.find('li').length && !recSlider.hasClass('slick-initialized')) {
      recSlider.slick({
        dots: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        variableWidth: true,
        centerMode: true,
        arrows: true,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 1021,
            slidesToShow: 6,
            slidesToScroll: 2,
          },
        ],
      });
    } else {
      $('.pdp__recommended').css('display', 'block');
    }
  };

  const activateRecommendations = () => {
    var ppb = $dom.recommendedDesktop.find('.promoted-products-box');
    if (!recommended) {
      var prevArrow = $('.pdp__recommended .sliderPrev').detach();
      var nextArrow = $('.pdp__recommended .sliderNext').detach();
      recommended = $('.pdp__reviews-content .promoted-products-box').detach();
      recommended.appendTo($dom.recommendedDesktop);
      $dom.recommendedDesktop.prepend(nextArrow);
      $dom.recommendedDesktop.prepend(prevArrow);
      ppb.removeClass('yotpo-hidden').css('display', 'block');
      $('.pdp__recommended').css('display', 'block');
      $dom.recommendedDesktop.find('.promoted-products-box').removeClass('yotpo-hidden').css('display', 'block');
    } else {
      ppb.removeClass('yotpo-hidden').css('display', 'block');
    }
    initRecommendationsSlider();
  };

  const scrollToElement = (el) => {
    $('html, body').animate(
      {
        scrollTop: $(el).offset().top - 118,
      },
      1000,
      'linear'
    );
  };

  const updatePrice = (element, quantity) => {
    const $self = $(element);
    const originalPrice = $self.attr('data-price');
    const newpriceMinimum = $dom.productPriceMinimum.attr('data-price') * quantity;
    const newPrice = originalPrice * quantity;
    const atcButtonText = $dom.addToCart.val();
    const newATCButtonText =
      atcButtonText.substring(0, atcButtonText.indexOf('$')) + Shopify.formatMoney(newpriceMinimum);
    //Take ATC button string before '$' char, re-add price

    if (typeof Shopify.formatMoney === 'function' && atcButtonText.indexOf('$') !== -1) {
      $self.html(Shopify.formatMoney(newPrice));
      $dom.addToCart.val(newATCButtonText);
    }
  };

  const activateMobileOptions = (event) => {
    if (isMobile() || isMobileBrowser()) {
      // pass identifier to map back to variant selector (up to 3 on PDPs)
      const variantSelectorId = $(event.currentTarget).closest('[data-options-block]').data('blockId');
      openMobileOptionMenu(variantSelectorId);
      $dom.mobileOptionMenu.focus();
    }
  };

  // creates new select menus based on quantity selected
  const changedQuantity = ($quantity) => {
    const $form = $quantity.closest('.js-product-form');
    const quantity = +$quantity.val();
    let count = 0;
    let $productOptionGroups = $form.find('.js-product-option-group');

    $dom.price.each((index, price) => {
      updatePrice(price, quantity);
    });

    if ($productOptionGroups.length <= 0) return;

    let multipleGroups = false;
    const variants = [];

    $productOptionGroups.each((index, $element) => {
      if (index < quantity) {
        const $el = $($element.outerHTML);
        variants.push($el.data('variant'));
        count++;
        return;
      }

      $element.remove();
    });

    while (count < quantity) {
      multipleGroups = true;
      count++;
      let groups = $productOptionGroups.length;
      const $newGroup = $($productOptionGroups[groups - 1].outerHTML);
      $newGroup.find('.js-product-index').html(count);
      const selectedVariant = variants.length === 1 ? variants[0] : variants[count - 2];

      const $optionsBlock = $newGroup.find('[data-options-block]');
      $optionsBlock.attr('data-block-id', count); // identifier for mobile options menu

      $dom.optionContainer.append($newGroup);
      $dom.optionContainer.find($newGroup).find('.js-variant-select').val(selectedVariant);
      changedVariant($newGroup.find('.js-variant-select'));
    }

    if (quantity > 1) {
      $dom.pdpFreeSamplesFootnote.addClass('show-footnote');
    } else {
      $dom.pdpFreeSamplesFootnote.removeClass('show-footnote');
    }

    cacheDom();

    if (!multipleGroups) {
      $('.js-bundle-variant-select').trigger('change');
      $('.js-variant-select').trigger('change');
    }
  };

  const handleThumbnailClick = (event) => {
    event.preventDefault();
    const $thumb = $(event.currentTarget);
    // update active class on thumbnail
    $dom.thumbnails.removeClass('active');
    $thumb.addClass('active');
    if (isMobile()) {
      const slide = $thumb.data('slide'); // get slide number
      $dom.productSlider.slick('slickGoTo', slide, true); // go to slide
    } else {
      // on desktop, set the featured image to the high res version of thumbnail
      const largeImageSrc = $thumb.find('img').data('high-res');
      $dom.desktopImageBlock.find('img').attr('src', largeImageSrc);
    }
  };

  // hide or show thumbnails based on current variant
  const variantImageChange = (variantAlt) => {
    let $slideImage = $('.product-thumbnails li');
    $slideImage.each((index, element) => {
      let slideAlt = $(element).data('variant-alt');
      if (slideAlt && slideAlt.length > 0) {
        if (slideAlt === variantAlt) {
          $(element).show();
        } else {
          $(element).hide();
        }
        // update featured image on desktop by simulating thumbnail click
        $('.product-thumbnails li:visible:first').click();
      }
    });
  };

  const changedVariant = ($selectOption) => {
    const selectedVariant = $selectOption.val();
    const selectedVariantAlt = $selectOption.data('variant-alt');
    const $optionGroups = $('.js-product-option-group');
    const variants = {};
    const originalEvent = window.event;
    let variantIsOutOfStock = false;
    $selectOption.closest('.js-product-option-group').attr('data-variant', selectedVariant);
    $selectOption.closest('.js-product-option-group').attr('data-variant-alt', selectedVariantAlt);
    $('.supplement-facts_element').addClass('supplement-facts_element--hide').attr('aria-hidden', 'true');
    $('.supplement-facts_element[data-variant-id=' + selectedVariant + ']')
      .removeClass('supplement-facts_element--hide')
      .attr('aria-hidden', 'false');

    $.getJSON(window.location.pathname + '.js').done((data) => {
      data.variants.forEach((variant) => {
        if (variant.inventory_management === null) {
          variants[variant.id] = 99;
          return;
        }

        variants[variant.id] = variant.inventory_quantity;
      });

      $optionGroups.each((index, option) => {
        const $option = $(option);
        const variantId = $option.attr('data-variant');
        const $info = $option.find('[js-product-options-info]');
        const $title = $option.find('[js-product-options-info-title]');

        if (variants[variantId] <= 0 || typeof variantId === 'undefined') {
          $option.find('.js-availability').html('Out of Stock');
          variantIsOutOfStock = true;
          return;
        }
        if (variants[variantId] > 0 && variants[variantId] < 100) {
          $option.find('.js-availability').html('Low in Stock');

          $info.addClass('is-low-in-stock');
          /*if($title.find('[js-low-in-stock-colon]').length==0){
            $title.append('<span js-low-in-stock-colon>: </span>');
          }*/
        } else {
          $option.find('.js-availability').html('In Stock');
          $info.removeClass('is-low-in-stock');
          $title.find('[js-low-in-stock-colon]').remove();
        }
        variants[variantId] -= 1;
      });

      // check here
      if (variantIsOutOfStock) {
        $dom.addToCart.addClass('disabled').attr('disabled', true);
        return;
      }

      $dom.addToCart.removeClass('disabled').attr('disabled', false);

      const JSONVariantSelected = [...data.variants].filter((variant) => variant.id === Number(selectedVariant));

      if (typeof originalEvent == 'undefined') {
        // return if event is not defined
        return;
      }

      // check if original event was triggered by the user
      if (originalEvent.isTrusted) {
        dataLayer.push({
          event: 'productDetailView',
          event_id: new Date().getTime() + '.' + Math.random().toString(36).substring(5),
          ecommerce: {
            currencyCode: Shopify.currency.active,
            detail: {
              actionField: { list: 'Product Page', list_location: 'isProduct' },
              products: [
                {
                  name: `${data.title}`,
                  id: `${JSONVariantSelected[0].sku}`,
                  productId: `${data.id}`,
                  variantId: `${JSONVariantSelected[0].id}`,
                  price: `${data.price / 100}`,
                  brand: `${data.vendor}`,
                  variant: `${JSONVariantSelected[0].title}`,
                  category: `${data.type}`,
                },
              ],
            },
            items: [
              {
                item_id: `${JSONVariantSelected[0].id}`,
                shopify_product_id: `${data.id}`,
                shopify_variant_id: `${JSONVariantSelected[0].id}`,
                shopify_sku: `${JSONVariantSelected[0].sku}`,
                shopify_handle: `${data.handle}`,
                item_name: `${data.title}`,
                affiliation: '1 Up Nutrition',
                currency: Shopify.currency.active,
                item_brand: `${data.vendor}`,
                item_category: `${data.type}`,
                item_list_id: 'product',
                item_list_name: 'product',
                item_variant: `${JSONVariantSelected[0].title}`,
                price: `${data.price / 100}`,
              },
            ],
          },
        });
      }
    });
  };

  const changedBundleVariant = ($selectOption) => {
    const sku = $selectOption.val();
    const $parent = $selectOption.closest('.js-product-option-group');
    const $bundleProducts = $parent.find('.js-bundle-product');
    const giftItem = $dom.giftOption.val();
    const skuArray = [];
    $selectOption.closest('.js-bundle-product').attr('data-sku', sku);

    $bundleProducts.each((index, product) => {
      const productSku = $(product).attr('data-sku');

      if (productSku) {
        skuArray.push(productSku.toLowerCase());
      }
    });

    if (giftItem) {
      skuArray.push(giftItem.toLowerCase());
    }

    const $variantSelect = $parent.find('.js-variant-select');
    const reformattedSKU = skuArray.join(';').split('').sort().join('');

    $variantSelect.find('option').each((index, option) => {
      const $option = $(option);
      const optionString = $option.text().toLowerCase().replace('- sold out', '').trim().split('').sort().join('');

      if (reformattedSKU === optionString) {
        $variantSelect.val($option.val());
        $variantSelect.trigger('change');
        setBundleVariantAvailability($variantSelect);
      }
    });
  };

  const changeHeight = () => {
    //adjust height of the line item container if there is the promo bar
    const promoMessage = $('.inline-cart-promo-message');
    const lineItemContainer = $('.inline-cart .line-items-container');
    const containerHeight = 550;
    const promoHeight = promoMessage.innerHeight();
    let height = lineItemContainer.innerHeight();

    if (promoMessage.length > 0) {
      height = containerHeight - promoHeight;
    }
    lineItemContainer.css('height', height);
  };

  const checkForProteinBars = () => {
    let proteinBarFound = false;
    $.each($('.js-variant-select option:selected'), function () {
      if ($(this).data('variant-alt').includes('protein-bar')) {
        proteinBarFound = true;
        return false;
      }
    });

    proteinBarSelected = proteinBarFound;
  };

  const disableProteinBarOptions = () => {
    $.each($('.js-variant-select option:not(:selected)'), function () {
      if ($(this).data('variant-alt').includes('protein-bar')) {
        $(this).attr('disabled', 'disabled');
      }
    });
    $('.js-style-select').selectric('destroy');
    $('.js-style-select').selectric({ stopPropagation: false });
  };

  const enableProteinBarOptions = () => {
    $.each($('.js-variant-select option:not(:selected)'), function () {
      if ($(this).data('variant-alt').includes('protein-bar')) {
        $(this).removeAttr('disabled');
      }
    });
    $('.js-style-select').selectric('destroy');
    $('.js-style-select').selectric({ stopPropagation: false });
  };

  const setBundleVariantAvailability = (variantSelect) => {
    const $variant = $(variantSelect.context.closest('.product-options__bundle'));
    const $label = $variant.find('.input-wrapper__label');
    const lowStock = $variant.find('.js-bundle-variant-select').find(':selected').is('[data-is-low-in-stock]');

    if (lowStock) {
      if (!$label.find('.product-options__availability').length) {
        $variant.addClass('is-low-in-stock');
        $label.append('<span class="product-options__availability">Low in Stock</span>');
      }
    } else {
      $variant.removeClass('is-low-in-stock');
      $label.find('.product-options__availability').remove();
    }
  };

  const prodArry = [];
  const itemArry = [];
  let item = {};
  const addedToCart = async ($element) => {
    const $form = $element.closest('.js-product-form');
    const $productGroups = $form.find('.js-product-option-group');
    const productGroupsCount = $productGroups.length;
    const $productFreeSamplesGroups = $form.find('.js-product-freesamples-option-group');
    const productFreeSamplesGroupsCount = $productFreeSamplesGroups.length;

    let totalATCRequests = productGroupsCount + productGroupsCount * productFreeSamplesGroupsCount;
    let atcRequestIndex = 0;
    let errors = '';

    const addItemToCart = (_variantId, _quantity, _properties) => {
      CartJS.addItem(_variantId, _quantity, _properties, {
        success: function (data) {
          jQuery.each(data.options_with_values, function (i) {
            const optionName = data.options_with_values[i].name;
            const optionValue = data.options_with_values[i].value;
            item = {
              item_id: data.variant_id,
              shopify_product_id: data.product_id,
              shopify_variant_id: data.variant_id,
              shopify_sku: data.sku,
              shopify_handle: data.handle,
              item_name: data.product_title,
              affiliation: Shopify.shop,
              currency: Shopify.currency.active,
              item_brand: data.vendor,
              item_category: data.product_type,
              item_list_id: 'product',
              item_list_name: 'product',
              item_variant: data.variant_title,
              [optionName]: optionValue,
              price: data.price / 100,
            };
          });

          data = {
            name: data.product_title,
            id: data.id,
            productId: data.product_id,
            variantId: data.variant_id,
            price: data.price / 100,
            brand: data.vendor,
            sku: data.sku,
            variant: data.variant_title,
            quantity: data.quantity,
            category: data.product_type,
          };
          atcRequestIndex++;
          itemArry.push(item);
          prodArry.push(data);

          if (atcRequestIndex === totalATCRequests && !errors) {
            InlineCart.toggle('show');
            dataLayer.push({
              event: 'addToCart',
              event_id: new Date().getTime() + '.' + Math.random().toString(36).substring(5),
              ecommerce: {
                currencyCode: Shopify.currency.active,
                items: itemArry,
                add: {
                  actionField: { list: 'Product Page', list_location: 'isProduct' },
                  products: prodArry,
                },
              },
            });
          }

          window.setTimeout(function () {
            InlineCart.discountGWP(0);
          }, 3000);
        },
        error: (error) => {
          atcRequestIndex++;
          if (error.status === 422 && error.responseJSON.description.indexOf('All') === 0) {
            if (errors.indexOf('Not enough items in stock.') === -1) {
              errors += 'Not enough items in stock. ';
            }
          } else {
            if (errors.indexOf('Could not add to cart, please try again.') === -1) {
              errors += 'Could not add to cart, please try again. ';
            }
          }

          if (atcRequestIndex === totalATCRequests) {
            alert(errors);
          }
        },
      });
    };

    const addProductQuantityFreeSamplesToCart = (variantId, productGroupIndex, $productFreeSamplesGroups) => {
      let variantLineItemInCart = CartJS.cart.items.find((item) => {
        return item.id == variantId;
      });
      let productQuantityInCart = typeof variantLineItemInCart !== 'undefined' ? variantLineItemInCart.quantity : 0;

      $productFreeSamplesGroups.each((productFreeSampleIndex, productFreeSampleGroup) => {
        const $productFreeSampleGroup = $(productFreeSampleGroup);
        const productFreeSampleVariantId = $productFreeSampleGroup.attr('data-variant');
        const productFreeSampleProperties = {
          _free_sample_for_variant_id: variantId,
          _free_sample_for_product:
            $form.closest('.product-form').find('meta[itemprop="name"]').attr('content') +
            ' - ' +
            $form.find('.js-variant-select option:selected').attr('data-variant-title'),
        };
        let propertiesQuantity, propertiesIndex, lineItemProperties;
        const propertiesChosen = {
          _chosen_by_customer: 'Yes',
        };

        if (productFreeSampleVariantId) {
          propertiesQuantity = {
            _free_sample_for_quantity: productQuantityInCart + productGroupIndex + 1,
          };
          propertiesIndex = {
            _free_sample_index: productFreeSampleIndex + 1,
          };
          lineItemProperties = { ...productFreeSampleProperties, ...propertiesQuantity, ...propertiesIndex };
          if (0 === productGroupIndex) {
            lineItemProperties = {
              ...productFreeSampleProperties,
              ...propertiesQuantity,
              ...propertiesIndex,
              ...propertiesChosen,
            };
          }
          addItemToCart(productFreeSampleVariantId, 1, lineItemProperties);
        }
      });
    };

    if (productGroupsCount === 0) {
      const variantId = $('.js-single-product-variant').val();
      const quantity = $('.js-product-quantity').val() * 1;
      let properties = {};
      let bundleSelectionValues = [];
    
      totalATCRequests = 1 + quantity * productFreeSamplesGroupsCount;
    
      if ($productFreeSamplesGroups.length > 0) {
        properties['_has_free_samples'] = true;
      }
    
      // [START] Simple Bundle App - Pass option selection as Custom Properties
      if ($('#simple-bundles-io-options').length > 0) {
        $('#simple-bundles-io-options select').each(function() {
          const selectedValue = $(this).val();
    
          if (selectedValue) {
            const label = $(this).prev('label').text();
            properties[label] = selectedValue;
            bundleSelectionValues.push(selectedValue);
          }
        });
      }
      if (bundleSelectionValues.length > 0) {
        properties["_bundle_selection"] = bundleSelectionValues.join(" <> ");
      }
      // [END] Simple Bundle App

      addItemToCart(variantId, quantity, properties);
    
      if ($productFreeSamplesGroups.length > 0) {
        for (let quantityIndex = 0; quantityIndex < quantity; quantityIndex++) {
          addProductQuantityFreeSamplesToCart(variantId, quantityIndex, $productFreeSamplesGroups);
        }
      }
    
      changeHeight();
      return;
    }

    let lastAtcVariantId = null;
    let productGroupRefIndex = 0;
    $productGroups.each((productGroupIndex, productGroup) => {
      const $productGroup = $(productGroup);
      const $bundleProducts = $productGroup.find('.js-bundle-product');
      const variantId = $productGroup.attr('data-variant');
      let properties = {};

      $bundleProducts.each((index, product) => {
        const $product = $(product);
        const $productSelect = $product.find('.js-bundle-variant-select');
        const productName = $product.attr('data-name');
        let productOption = '';
        const obj = {};
        if ($productSelect.length) {
          const productValue = $productSelect.val();
          productOption = $productSelect.find('[value=' + productValue + ']').text();
        }
        if (properties[productName]) {
          //if item already exists in bundle object, append "(xIndex)" to the key
          obj[productName + ' (' + (index + 1) + ')'] = productOption;
        } else {
          obj[productName] = productOption;
        }
        properties = { ...properties, ...obj };
      });

      if (variantId) {
        if ($productFreeSamplesGroups.length > 0) {
          properties['_has_free_samples'] = true;
        }
        addItemToCart(variantId, 1, properties);

        if (lastAtcVariantId !== null && lastAtcVariantId !== variantId) {
          productGroupRefIndex = 0;
        }

        addProductQuantityFreeSamplesToCart(variantId, productGroupRefIndex, $productFreeSamplesGroups);
      }

      productGroupRefIndex++;
      lastAtcVariantId = variantId;
    });
  };

  const initBundleSelection = () => {
    const bundleSelect = $('.js-bundle-variant-select');
    if (bundleSelect) {
      bundleSelect.trigger('change');
    }
  };

  const initQuantitySelection = () => {
    if (isSampleBundle()) {
      $('.js-style-select').selectric('destroy');
      const sampleBundleOf = typeof window.sampleBundleOf != 'undefined' ? window.sampleBundleOf : 5;
      $dom.quantitySelector.val(sampleBundleOf);
    } else {
      $dom.quantitySelector.val(1);
    }

    $dom.quantitySelector.trigger('change');
  };

  const openVideoModal = (videoCode) => {
    let modal = $('.video-modal');
    let span = $('.video-modal .close');

    $('.video-modal .video-here').html(videoCode);
    $('.modal-video-content').css('opacity', '1');
    $(modal).css('display', 'block');

    $(span).click(function () {
      $('.modal-video-content').css('opacity', '0');
      $('.video-here iframe').html('');
      $('.video-here iframe').attr('src', '');
      setTimeout(function () {
        $(modal).css('display', 'none');
      }, 400);
    });

    $(window).click(function (event) {
      if (event.target.id == 'product-video') {
        $('.video-here iframe').html('');
        $('.video-here iframe').attr('src', '');
        $('.modal-video-content').css('opacity', '0');
        setTimeout(function () {
          $(modal).css('display', 'none');
        }, 400);
      }
    });
  };

  const initVideoModal = () => {
    $('.product-thumbnails img').click(function () {
      if ($(this).attr('data-open')) {
        const videoData = $(this).attr('data-video');
        const videoDataSplit = videoData.split('<br />');
        const videoCode = videoDataSplit[0];
        openVideoModal(videoCode);
      }
    });
  };

  const isSampleBundle = () => {
    return $dom.quantitySelector.hasClass('js-sample-bundle');
  };

  const showSecondModalScreen = () => {
    const firstScreen = $('[data-first-screen]');
    const secondScreen = $('[data-second-screen]');

    firstScreen.hide();
    secondScreen.show();
  };

  const showFirstModalScreen = () => {
    const firstScreen = $('[data-first-screen]');
    const secondScreen = $('[data-second-screen]');

    secondScreen.hide();
    firstScreen.show();
  };

  /*
      opens mobile menu
      variantSelectorId -> identifier to map the specific menu choice back to the corresponding select menu
      fromResponsiveDesktop -> covers an edge case for mobile-sized windows on desktop browsers (QA callout)
  */
  const openMobileOptionMenu = (variantSelectorId, fromResponsiveDesktop = false) => {
    $dom.mobileOptionMenu.attr('data-block-id', variantSelectorId);
    $dom.mobileOptionMenu.addClass('active');
    if (fromResponsiveDesktop) $dom.mobileOptionMenu.attr('data-small-desktop-window', true);
    Scroll.lock();
  };

  const closeMobileOptionMenu = () => {
    Scroll.unlock();
    $dom.mobileOptionMenu.removeClass('active');
  };
  const initNutritionSelect = () => {
    $('.js-nutrition-select').selectric({});
  };

  const initManufacturingVideoExpand = () => {
    let manuf_video_button = document.querySelector('.manufacturing-video_button');
    let manuf_video_expanding_container = document.querySelector('.manufacturing-video_expanding-container');

    if (manuf_video_button) {
      manuf_video_button.addEventListener('click', () => {
        console.log($(this));
        let expanded = manuf_video_expanding_container.getAttribute('aria-expanded') === 'true';
        manuf_video_button.setAttribute('aria-expanded', !expanded);
        manuf_video_expanding_container.classList.toggle('manufacturing-video_expanding-container--visible');
        manuf_video_expanding_container.hidden = expanded;
        manuf_video_button.innerHTML = manuf_video_button.innerHTML == 'View Less' ? 'View More' : 'View Less';
      });
    }
  };

  const bindUIActions = () => {
    // listen for selectric events on mobile-sized browser windows (should be routed to the mobile menu functionality)
    // this use-case only matters on desktop browsers with mobile/tablet-sized windows
    $('.js-style-select').on('selectric-highlight', function (event, element, selectric) {
      if (isMobile()) {
        // prevent selectric from opening on mobile
        $(element).selectric('close');
        const variantSelectorId = $(event.currentTarget).closest('[data-options-block]').data('blockId');
        openMobileOptionMenu(variantSelectorId, true);
        $dom.mobileOptionMenu.focus();
      }
    });

    if ($dom.infoList && $dom.infoList.length) {
      $dom.infoList.click((e) => {
        e.preventDefault();
        var product = $(e.currentTarget).data('product') - 1;
        $dom.infoList.removeClass('active');
        $(e.currentTarget).addClass('active');
        $dom.infoContent.css('display', 'none');
        $dom.infoContent.eq(product).css('display', 'flex');
      });
    }

    if ($dom.mobileAccordionHeaders && $dom.mobileAccordionHeaders.length) {
      $dom.mobileAccordionHeaders.click((e) => {
        var header = $(e.currentTarget);
        var content = header.next('.pdp-accordion-content');
        var onOff = $(e.currentTarget).hasClass('active');

        $dom.mobileAccordionHeaders.removeClass('active');
        $dom.mobileAccordionContent.css('display', 'none');
        if (onOff) {
          header.removeClass('active');
          content.slideUp();
        } else {
          header.addClass('active');
          content.slideDown(scrollToElement(header));
        }
      });
    }

    $('.view-description-long').click(function (e) {
      e.preventDefault(),
        $('.description-short').hide(),
        $('.description-long').show(),
        $('html,body')
          .stop()
          .animate({ scrollTop: $('.description').offset().top + -200 }, 'linear');
    });

    // return to description from Full Ingredients
    $('.view-description-short').click((e) => {
      e.preventDefault();
      $('.description-short').show();
      $('.description-long').hide();
    });

    $('.pdp__recommended').on('click', '.sliderPrev', () => {
      recSlider.slick('slickPrev');
    });

    $('.pdp__recommended').on('click', '.sliderNext', () => {
      recSlider.slick('slickNext');
    });
    
    const yotpoStarsClick = () => {
      const target = $('.yotpo-widget-instance');
      const desktopYotpoTarget = target.last().addClass('desktop-yotpo-widget');
      $('.pdp__stars-desktop').on('click', () => {
        $('html, body').animate(
          {
            scrollTop: desktopYotpoTarget.offset().top - 60,
          },
          1000
        );
      });
    }
    yotpoStarsClick();

    // wait for yotpo bottomLine
    $('[data-review-scroll]').on('click', () => {
      $('.pdp__stars-mobile .pdp-accordion-header').trigger('click');
    });

    var mobileDropdowns = $('.slBundleDropdown').msDropDown();
    $('.pdp__benefits-mobile .bundleProduct').eq(0).css('display', 'block');
    $('.pdp__ingredients .bundleProduct').eq(0).css('display', 'block');
    mobileDropdowns.change((e) => {
      var slc = $(e.currentTarget);
      var selection = slc.val();
      var bundleProducts = slc.parent().parent().find('.bundleProduct');
      bundleProducts.hide();
      bundleProducts.eq(selection).show();
    });

    var venoboxLightbox = $('.venobox').venobox({
      overlayColor: 'rgba(124,124,124,0.85)',
    });

    $(document).on('click touchend', '.vbox-content', (e) => {
      e.stopPropagation();
    });

    $(document).on('click touchend', '.vbox-container, .vbox-close, .pdp-modal-close', (e) => {
      showFirstModalScreen();
      venoboxLightbox.VBclose();
    });

    $(document).on('click touchend', '[data-facts-link]', (event) => {
      const $this = $(event.currentTarget);
      if ($this.data('scroll') !== undefined) {
        window.scrollTo({
          top: $('#pdp-benefits-block').offset().top - 150,
          behavior: 'smooth',
        });
      }
      if ($this.data('mobile-scroll') !== undefined) {
        window.scrollTo({
          top: $('#pdp-supplements-mobile').offset().top - 150,
          behavior: 'smooth',
        });
        if (!$('#pdp-supplements-mobile').find('.pdp-accordion-header').hasClass('active')) {
          $('#pdp-supplements-mobile').find('.pdp-accordion-header').addClass('active');
          $('#pdp-supplements-mobile').find('.pdp-accordion-content').slideDown();
        }
      }
    });

    $(document).on('click touchend', '[data-modal-screen]', () => {
      showSecondModalScreen();
    });

    $(document).on('click touchend', '[data-modal-back]', () => {
      showFirstModalScreen();
    });

    $dom.window.on('load', () => {
      activateRecommendations();
    });

    $dom.window.on('resize', () => {
      activateRecommendations();
    });

    $dom.quantityButtons.on('click', (event) => {
      const action = $(event.currentTarget).data('action');
      const currentQuantity = parseInt($dom.quantitySelector.val());
      const quantityLimit = parseInt($dom.quantitySelector.data('limit'));

      // XXXXXXXXXXXX

      if (action === 'minus') {
        // reduce quantity
        if (currentQuantity !== 1) {
          // update hidden qty select
          $dom.quantitySelector.val(currentQuantity - 1);
          $dom.quantitySelector.trigger('change');
          // update the visible quantity
          $('[data-current-quantity]').text(currentQuantity - 1);
        }
      } else {
        // increase quantity
        if (currentQuantity !== quantityLimit) {
          // update hidden qty select
          $dom.quantitySelector.val(currentQuantity + 1);
          $dom.quantitySelector.trigger('change');
          // update the visible quantity
          $('[data-current-quantity]').text(currentQuantity + 1);
        }
      }
    });

    // triggers number of selectric menus to update based on new quantity
    $dom.quantitySelector.on('change', (event) => {
      const $self = $(event.currentTarget);
      $('.js-style-select').selectric('destroy');
      changedQuantity($self);
      $('.js-style-select').selectric({ stopPropagation: false });
    });

    $dom.optionContainer.on('change', '.js-variant-select', (event) => {
      const $self = $(event.currentTarget);
      let $variantAlt = $self.find(':selected').data('variant-alt');
      const $altValueSelected = $self.find(':selected').val();
      const $index = $self.find(':selected').index();

      $('.js-variant-select.js-nutrition-select').each(function () {
        const $altSelect = $(this).find(':selected').data('variant-alt');
        if ($altSelect.trim() !== $variantAlt.trim()) {
          $('.js-variant-select.js-nutrition-select').selectric('refresh');
          $(this).prop('selectedIndex', $index).selectric('refresh');
          $('.js-variant-select.js-nutrition-select').val($altValueSelected);
        }
      });
      changedVariant($self);
      variantImageChange($variantAlt);

      Slider.filterMobileProductSlider($variantAlt);

      if (window.limitProteinBars) {
        checkForProteinBars();
        if (proteinBarSelected) {
          disableProteinBarOptions();
        } else {
          enableProteinBarOptions();
        }
      }
    });

    $('.js-variant-select.js-nutrition-select')
      .selectric()
      .on('change', (event) => {
        const $self = $(event.currentTarget);
        const selectedValue = $(this).val();
        let $variantAlt = $self.find(':selected').data('variant-alt');
        const $altValueSelected = $self.find(':selected').val();
        const $index = $self.find(':selected').index();

        $('.js-variant-select').each(function () {
          const $altSelect = $(this).find(':selected').data('variant-alt');
          if ($altSelect.trim() !== $variantAlt.trim()) {
            $('.js-variant-select.js-nutrition-select').selectric('refresh');
            $(this).prop('selectedIndex', $index).selectric('refresh');
            $('.js-variant-select.js-nutrition-select').val($altValueSelected);
            $('.js-product-option-group').attr('data-variant', $altValueSelected);
          }
        });
        changedVariant($self);
        variantImageChange($variantAlt);
        Slider.filterMobileProductSlider($variantAlt);
      });

    // update PDP Free Samples variant
    $dom.pdpFreeSamplesOptionContainer.on('change', '.js-pdpfreesample-variant-select', (event) => {
      const $self = $(event.currentTarget);
      $self.closest('.js-product-freesamples-option-group').attr('data-variant', $self.val());
    });

    // open mobile variant selector
    $(document).on('mousedown', '.js-variant-select', (event) => {
      event.preventDefault();
      event.currentTarget.blur();
      activateMobileOptions(event);
    });

    // select mobile variant from options menu
    $dom.mobileOptionButtons.on('click', (event) => {
      event.preventDefault();
      const variantAlt = $(event.currentTarget).data('variantAlt');
      const $mobileMenu = $(event.currentTarget).closest('[data-mobile-options]');
      const variantSelectorId = $mobileMenu.attr('data-block-id');
      // set the corresponding variant selector to the selected option
      const $variantSelector = $(`[data-options-block][data-block-id="${variantSelectorId}"] .js-variant-select`);
      const $optionValue = $variantSelector.find(`option[data-variant-alt="${variantAlt}"]`).val();
      $variantSelector.val($optionValue);
      $variantSelector.trigger('change');
      // uncommon use-case where selectric is still active on desktop with a mobile-sized viewport
      if (
        $mobileMenu.attr('data-small-desktop-window') !== 'undefined' &&
        $mobileMenu.attr('data-small-desktop-window') === 'true'
      ) {
        $('.js-style-select').selectric('refresh');
      }
      closeMobileOptionMenu();
    });

    $dom.mobileOptionMenuCloseButton.on('click touchend', (event) => {
      closeMobileOptionMenu();
    });

    // update active class + go to corresponding slide
    $dom.thumbnails.click((e) => handleThumbnailClick(e));

    // update featured image when switching from mobile to desktop
    $dom.productSlider.on('destroy', () => {
      const currentVariant = $('.js-variant-select option:selected').data('variant-alt');
      variantImageChange(currentVariant);
    });

    $dom.optionContainer.on('change', '.js-bundle-variant-select', (event) => {
      const $self = $(event.currentTarget);
      changedBundleVariant($self);
    });

    $dom.giftOption.on('change', () => {
      initBundleSelection();
    });

    $dom.addToCart.on('click', (event) => {
      event.preventDefault();
      const $self = $(event.currentTarget);
      addedToCart($self);
    });
  };

  Product.init = () => {
    cacheDom();
    processLineBreaks();
    bindUIActions();
    setSavings();
    initVideoModal();
    initQuantitySelection();
    initBundleSelection();
    initManufacturingVideoExpand();
  };
})((window.Product = window.Product || {}), jQuery);

// AJAX get product by product.handle - /products/HANDLE?view=json
const getProductByHandle = async (productHandle) => {
  try {
    const response = await fetch(`/products/${productHandle}?view=json`);
    if (!response.ok) {
      throw new Error(`Failed to fetch product: ${response.status} ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    throw new Error('Failed to fetch product. Please try again later.');
  }
};

function getTwoDifferentFreeSample(product) {
  const getFreeSamples = product.variants.filter((variant) => variant.inventory_quantity > 2);
  return getFreeSamples.slice(0, 2);
}

// delay async function
function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

// Function to generate free sample items dynamically
function generateFreeSampleItems(freeSample, product) {
  const freeSamples = getTwoDifferentFreeSample(freeSample);

  const freeSampleItems = freeSamples.map((variant, index) => ({
    id: variant.id,
    quantity: 1,
    properties: {
      _free_sample_for_quantity: '1',
      _free_sample_for_variant_id: `${product.id}`,
      _free_sample_index: `${index + 1}`,
      _free_sample_for_product: `${product.product_title}`,
      _chosen_by_customer: 'Yes',
    },
  }));

  return { items: freeSampleItems };
}

// Hook into the Rebuy event when a product is added to the cart
document.addEventListener('rebuy:cart.add', async (event) => {
  const product = event.detail.item;

  try {
    // Retrieve the free sample product and cart data simultaneously
    const [freeSample, cartResponse] = await Promise.all([
      getProductByHandle('free-samples'),
      fetch(`${window.Shopify.routes.root}cart.js`),
    ]);

    const cart = await cartResponse.json();

    // Check if free sample already exists in the cart
    const freeSampleExists = cart.items.some(
      (item) => String(item.properties._free_sample_for_variant_id) === String(product.id)
    );

    // Add free samples to the cart if they don't exist already
    if (!freeSampleExists && product.properties._source === 'Rebuy') {
      const requestData = {
        id: `${product.key}`,
        properties: {
          ...product.properties,
          _has_free_samples: 'true',
        },
      };

      // Add "_has_free_samples" custom property to the product
      await fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData),
      });

      // Prepare data for free samples
      const freeSamples = generateFreeSampleItems(freeSample, product);

      // Add free samples to the cart
      await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(freeSamples),
      });
    }
  } catch (error) {
    console.error('Error:', error);
  }
});

// Make sure to remove 'free-sample' products when
// associated products are removed from cart
window.addEventListener('item-removed', async (event) => {
  const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
  const cart = await cartResponse.json();
  const itemsToRemove = cart.items.filter((item) => {
    if (item.properties && item.properties._free_sample_for_variant_id) {
      const matchingItem = cart.items.find(
        (otherItem) => otherItem.variant_id === parseInt(item.properties._free_sample_for_variant_id)
      );
      return !matchingItem;
    }
    return false;
  });

  const keysToRemove = itemsToRemove.map((item) => ({
    id: item.key,
    quantity: 0,
  }));

  const removeItemsFromCart = async (item) => {
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(item),
      });

      if (response.ok) {
        console.log('Item removed successfully from the cart.');
      } else {
        console.error('Failed to remove item from the cart.');
      }
    } catch (error) {
      console.error('Error occurred:', error);
    }
  };

  const removeItemsFromCartAsync = async () => {
    for (const item of keysToRemove) {
      await removeItemsFromCart(item);
    }
  };

  if (itemsToRemove.length > 0) {
    await removeItemsFromCartAsync();
  }
});

// Yotop mobile scroll when stars on PDP are clicked
const isElementLoaded = async (selector) => {
  while (document.querySelector(selector) === null) {
    await new Promise((resolve) => requestAnimationFrame(resolve));
  }
  return document.querySelector(selector);
};

isElementLoaded('.yotpo-reviews-star-ratings-widget').then(() => {
  var content = document.querySelector('.pdp__stars-mobile');
  var bottomline = document.querySelector('.yotpo-reviews-star-ratings-widget');

  bottomline.addEventListener('click', function () {
    content.scrollIntoView({ behavior: 'smooth' });
    var reviewsContainer = document.querySelector('.pdp-accordion-content');
    reviewsContainer.style.display = 'block';

    var reviewsTab = document.querySelector('.pdp__stars-mobile pdp-accordion .pdp-accordion-header');

    // Check if reviewsTab and reviewsTab.classList exist before using them
    if (reviewsTab && reviewsTab.classList) {
      reviewsTab.classList.add('active');
    }
  });
});
